import React from 'react';

export default function NotFound() {
  return <div style={{ paddingTop: '100px', textAlign: 'center', color: 'black' }}>No page found.</div>;
}
